import React from 'react';
import {Box, Grid, Typography} from '@deere/fuel-react';
import {toRound} from "../shared/utils";
import {AVERAGE, NO_CAMPAIGN_SENT, NO_RESPONSES, NOT_INCLUDED_IN_CAMPAIGNS} from "../shared/Constants";

export const RatingCampaignsData = ({
                                        supplierData,
                                        supplierFeedbacks,
                                        responses,
                                        averageStarRating,
                                        recordedResponses,
                                        commentsCount,
                                        type,
                                        ChartsGraphs,
                                        chartData,
                                        criteria,
                                        noOfYes,
                                        totalYesOrNo,
                                        isResponseCountVisible
                                    }) => {

    return (
        <Grid item xs={12} md={4}>
            <Box display="flex"
                 justifyContent="flex-end">
                {!supplierData.campaignSent ?
                    <Typography color="tertiary" size="md">
                        {NO_CAMPAIGN_SENT}
                    </Typography>
                    :
                    <>
                        {supplierFeedbacks.length !== 0 ?
                            <Grid container alignItems="center">
                                {responses.length === 0 ?
                                    <Grid item xs={12}>
                                        <Box display="flex"
                                             justifyContent="flex-end">
                                            <Typography color="tertiary"
                                                        size="md">
                                                {NO_RESPONSES}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    :
                                    type === "likertScale" ?
                                        <Grid item xs={12}>
                                            <Box display="flex"
                                                 justifyContent="flex-end">
                                                <Typography size="md"
                                                            fontWeight="semibold"
                                                            display="inline">
                                                    {AVERAGE}: {toRound(averageStarRating)}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        :
                                        <Grid item xs={12}>
                                            <Box display="flex"
                                                 justifyContent="flex-end">
                                                <Box style={{opacity: .5}}>
                                                    <ChartsGraphs
                                                        type="pie"
                                                        data={chartData}
                                                        height={25} width={25}
                                                        id={criteria.id}
                                                        options={{
                                                            legend: {
                                                                display: false
                                                            }
                                                        }}
                                                    />
                                                </Box>
                                                <Typography size="md"
                                                            fontWeight="regular"
                                                            display="inline">
                                                    &nbsp; {noOfYes}/{totalYesOrNo} Yes
                                                </Typography>
                                            </Box>
                                        </Grid>
                                }
                                {isResponseCountVisible &&
                                <Grid item xs={12}>
                                    <Box display="flex"
                                         justifyContent="flex-end" mr={2}>
                                        <Typography color="tertiary"
                                                    size="sm">
                                            {recordedResponses.length}/{supplierFeedbacks.length} Responses, {commentsCount} {commentsCount === 1 ? 'Comment' : 'Comments'}
                                        </Typography>
                                    </Box>
                                </Grid>
                                }
                            </Grid>
                            :
                            <Typography color="tertiary" size="md">
                                {NOT_INCLUDED_IN_CAMPAIGNS}
                            </Typography>
                        }
                    </>
                }
            </Box>
        </Grid>
    )
}
